import { http } from 'msw';
import vars from '@/config/vars';
import { ENDPOINTS } from '@/helpers/enums';
import { localesHeHandler } from './locales.handler';
import { loginHandler } from './login.handler';
import { otpHandler } from './otp.handler';
import { retrievalHandler } from './offerRetrieval.handler';
import { counselorHandler } from './counselor.handler';
import { slotsHandler } from './slots.handler';
import { meetingHandler } from './meeting.handler';

const { baseUrl } = vars.request;
const handlers = [];

const localesHandlers = [
  http.get(ENDPOINTS.locales, localesHeHandler),
];

// TODO: create mocks for all endpoints (enums.js endpoints)

const restHandlers = [
  http.post(ENDPOINTS.login, loginHandler),
  http.post(ENDPOINTS.otp, otpHandler),
  http.post(`${baseUrl}/v1/calculation/calculateOfferForKnownPeriodAndRiskById`, retrievalHandler), // TODO: ???
  http.post(ENDPOINTS.counselorList, counselorHandler),
  http.post(ENDPOINTS.meetingSlots, slotsHandler),
  http.post(ENDPOINTS.meetingCreate, meetingHandler),
];

if (vars.mocks.locales) {
  handlers.push(...localesHandlers);
}

if (vars.mocks.rest) {
  handlers.push(...restHandlers);
}

export default handlers;
